export function inputProps(name, props) {
  return {
    name,
    value: props.values[name],
    error: props.errors[name],
    touched: props.touched[name],
    onChange: props.handleChange,
    onBlur: props.handleBlur,
  };
}

export function selectProps(name, props) {
  return {
    ...inputProps(name, props),
    onChange: value => props.setFieldValue(name, value),
    onFocus: props.handleFocus,
    optionFilterProp: 'children',
    showSearch: true,
  };
}
